import { defineMessages } from 'react-intl';

const scope = 'app.widgets.RecommendationsCalendar';

export default defineMessages({
    availableRecommendation: {
        id: `${scope}.availableRecommendation`,
        defaultMessage: 'There is an available recommendation for this date. Click to view it.',
    },
});
